import { Button, ButtonBase, IconSocialApple24, IconSocialFacebookCircle24, IconSocialGoogleColor24 } from '@stitch-fix/mode-react';
import classNames from 'classnames';
import styles from './styles.module.scss';
export const SocialButton = ({
  compact = false,
  mode,
  onClick,
  variant
}: {
  compact?: boolean;
  mode: 'login' | 'signup';
  onClick: () => void;
  variant: 'apple' | 'facebook' | 'google';
}) => {
  const Icon = {
    apple: IconSocialApple24,
    google: IconSocialGoogleColor24,
    facebook: IconSocialFacebookCircle24
  }[variant];
  const appName = variant.charAt(0).toUpperCase() + variant.slice(1);
  return compact ? <ButtonBase className={classNames(styles.socialButton, styles[variant])} onClick={onClick} aria-label={`Continue with ${appName}`}>
      {appName}
      <Icon purpose="decorative" />
    </ButtonBase> : <Button variant={variant} startIcon={<Icon />} width="fill" onClick={onClick} data-testid={`${variant}-button`}>
      {mode === 'login' ? `Sign In with ${appName}` : `Continue with ${appName}`}
    </Button>;
};